import { logAPI } from "./andyliticsApi";
import * as Tools from "../helpers/Tools";
import employeeTypes from "../employeeTypes.json";

const BASE_URL = window.serverData.data.portalAPIURL;

/**
 * Returns search results for the site.
 * 
 * @param {any} searchphrase the words to search for
 * @param {any} token the user token
 * 
 * @returns {any} consent model
 */
export const search = (searchphrase, token) => {
    const fullUrl = `${BASE_URL}/api/sitesearch/search?SearchPhrase=${searchphrase}`;

    let params = {
        headers: {
            authorization: `bearer ${token}`
        },
        method: "GET"
    };

    var start = new Date();

    return fetch(fullUrl, params)
        .then(response => {
            logAPI("Api.Portal.SiteSearch.Search.Success", start, fullUrl);
            return response.json();
        })
        .catch(err => {
            logAPI("Api.Portal.SiteSearch.Search.Failure", start, fullUrl);
            return Promise.reject(err);
        });
};

export const getEpicDepartmentList = (token) => {
    const fullUrl = `${BASE_URL}/api/epic/GetDepartmentList`;

    const params = {
        headers: {
            authorization: `bearer ${token}`,
            "Cache-Control": "no-cache",
            "Pragma": "no-cache"
        },
        method: "GET"
    };

    const start = new Date();

    return fetch(fullUrl, params).then(response => {
        logAPI("Api.Portal.EpicDepartmentList.Get", start, fullUrl);
        return response.json();
    }).catch(err => {
        logAPI("Api.Portal.EpicDepartmentList.Get.Failure", start, fullUrl);
        return Promise.reject(err);
    });
};

export const getTermsAndConditions = (userName, token) => {

    //debugger;

    const url = `${BASE_URL}/TCC/FetchCurrent`;
    const params = {
        method: "POST",
        body: JSON.stringify({ UserName: userName }),
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json"
        },
    };
    var start = new Date();

    //debugger;  

    return fetch(url, params).then(response => {
        //debugger;                            
        logAPI("Api.TermsConditions.ById.Get", start, url);
        if (response.status >= 200 && response.status < 300) {
            //debugger;           
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch((e) => {
        logAPI("Api.TermsConditions.ById.Get.Failure", start, url, e);
        return Promise.resolve({ id: 3, isAccepted: true, isSuccessful: false, statusCode: 0, versionId: 2 });
    }
    );
};

export const acceptTermsAndConditions = (token, userName, version) => {

    const url = `${BASE_URL}/TCC/AcceptCurrent`;

    const params = {
        method: "POST",
        body: JSON.stringify({ UserName: userName, VersionId: version }),
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json"
        },
    };
    var start = new Date();

    //debugger;

    return fetch(url, params).then(response => {
        //debugger;
        logAPI("Api.TermsConditions.Accept.Post", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => { logAPI("Api.TermsConditions.Accept.Post.Failure", start, url, err); return Promise.reject(err); });
};

export const getAppUpdate = (token) => {
    var start = new Date();
    const url = '/tm/appUpdate';
    let params = {
        headers: {
            "Authorization": `bearer ${token}`,
            "Cache-Control": "no-cache",
            "Pragma": "no-cache"
        },
        method: "GET"
    };
    return fetch2(url, params).then(response => {
        logAPI("Api.GetAppUpdate", start, url);
        return response;
    }).catch(err => { logAPI("Api.GetAppUpdate.Failure", start, url, err); return Promise.reject(err); });
};

//export const getRoomStatuses = (token) => {
//    const url = Tools.buildUrl(BASE_URL, '/api/v1/video/GetRoomStatuses');
//    const params = {
//        method: "GET",
//        headers: {
//            "Authorization": `bearer ${token}`,
//            "Accept": "application/json",
//            "Content-type": "application/json"
//        }
//    };

//    var start = new Date();

//    return fetch(url, params)
//        .then(resp => {
//            logAPI("MBHWeb.Api.VideoVisit.GetRoomStatuses", start, url);
//            return response.json();
//        })
//        .catch(err => {
//            logAPI("MBHWeb.Api.VideoVisit.GetRoomStatuses.Failure", start, url, err);
//            return Promise.reject(err);
//        });
//};

export const getConsumerJWT = (token, participantExternalId, participantName, csnId, epicExternalProviderId, apiVersion) => {
    if (apiVersion !== 1 || apiVersion !== 2) {
        apiVersion = 1;
    }
    const url = Tools.buildUrl(BASE_URL, `/api/v${apiVersion}/video/ConsumerToken`);
    const postData = {
        participantId: participantExternalId,
        participantIdType: "External",
        participantRole: "Patient",
        participantName: participantName,
        csnId: csnId,
        epicExternalProviderId: epicExternalProviderId
    };

    const params = {
        method: "POST",
        headers: {
            //"Authorization": `bearer ${token}`,
            "Accept": "application/json",
            "Content-type": "application/json"
        },
        body: JSON.stringify(postData)
    };

    const start = new Date();

    return fetch(url, params)
        .then(resp => {
            logAPI("MBHWeb.Api.VideoVisit.GetConsumerJWT", start, url, null, csnId);
            return resp.json();
        })
        .catch(err => {
            logAPI("MBHWeb.Api.VideoVisit.GetConsumerJWT.Failure", start, url, err, csnId);
            return Promise.reject(err);
        });

};

export const getProviderJWT = (token, participantExternalId, participantName, participantRole, roomId, apiVersion) => {
    if (apiVersion !== 1 && apiVersion !== 2) {
        apiVersion = 1;
    }
    const url = Tools.buildUrl(BASE_URL, `/api/v${apiVersion}/video/ProviderToken`);

    const postData = {
        participantId: participantExternalId,
        participantIdType: "External",
        participantRole: participantRole,
        participantName: participantName,
        roomId: roomId
    };

    const params = {
        method: "POST",
        headers: {
            "Authorization": `bearer ${token}`,
            "Accept": "application/json",
            "Content-type": "application/json"
        },
        body: JSON.stringify(postData)
    };

    const start = new Date();

    return fetch(url, params)
        .then(resp => {
            logAPI("MBHWeb.Api.VideoVisit.GetProviderJWT", start, url, null, roomId);
            return resp.json();
        })
        .catch(err => {
            logAPI("MBHWeb.Api.VideoVisit.GetProviderJWT", start, url, null, roomId);
            return Promise.reject(err);
        });
};

export const getPatientDemographics = (token, id, idType) => {
    const fullUrl = Tools.buildUrl(BASE_URL, `/api/patient/getpatientdemographics?id=${id}&idType=${idType}`);
    const params = {
        method: "GET",
        headers: {
            authorization: `bearer ${token}`,
            "Accept": "application/json",
            "Content-type": "application/json"
        }
    };

    const start = new Date();

    return fetch(fullUrl, params)
        .then(response => {
            if (response.status === 200) {
                logAPI("MBHWeb.Api.VideoVisit.PatientDemographics.Get.Success", start, fullUrl);
                return response.json();
            }
            else {
                logAPI("MBHWeb.Api.VideoVisit.PatientDemographics.Get..Failure", start, fullUrl);
                return Promise.reject(response);
            }
        })
        .catch(err => {
            logAPI("MBHWeb.Api.VideoVisit.PatientDemographics.Get.Failure", start, fullUrl);
            return Promise.reject(err);
        });
};

export const smsVideoVisitLink = (token, room, mobileNumber, participantName) => {
    const fullUrl = Tools.buildUrl(BASE_URL, `/api/v2/video/SmsVideoVisitLink?room=${room}&mobileNumber=${mobileNumber}&participantName=${participantName}`);
    const params = {
        method: "POST",
        headers: {
            authorization: `bearer ${token}`,
            "Accept": "application/json",
            "Content-type": "application/json"
        }
    };

    const start = new Date();

    return fetch(fullUrl, params)
        .then(response => {
            if (response.status === 200) {
                logAPI("MBHWeb.Api.VideoVisit.SMSVisitLink.Success", start, fullUrl, { room, mobileNumber, participantName }, room);
                return response.json();
            }
            else {
                logAPI("MBHWeb.Api.VideoVisit.SMSVisitLink.Failure", start, fullUrl, { room, mobileNumber, participantName }, room);
                return Promise.reject(response);
            }
        })
        .catch(err => {
            logAPI("MBHWeb.Api.VideoVisit.SMSVisitLink.Failure", start, fullUrl, { room, mobileNumber, participantName }, room);
            return Promise.reject(err);
        });
};

export const emailVideoVisitLink = (token, room, email, participantName) => {
    const fullUrl = Tools.buildUrl(BASE_URL, `/api/v2/video/EmailVideoVisitLink?room=${room}&email=${email}&participantName=${participantName}`);
    const params = {
        method: "POST",
        headers: {
            authorization: `bearer ${token}`,
            "Accept": "application/json",
            "Content-type": "application/json"
        }
    };

    const start = new Date();

    return fetch(fullUrl, params)
        .then(response => {
            if (response.status === 200) {
                logAPI("MBHWeb.Api.VideoVisit.EmailVisitLink.Success", start, fullUrl, { room, email, participantName }, room);
                return response.json();
            }
            else {
                logAPI("MBHWeb.Api.VideoVisit.EmailVisitLink.Failure", start, fullUrl, { room, email, participantName }, room);
                return Promise.reject(response);
            }
        })
        .catch(err => {
            logAPI("MBHWeb.Api.VideoVisit.EmailVisitLink.Failure", start, fullUrl, { room, email, participantName }, room);
            return Promise.reject(err);
        });
};

export const smsVideoVisitLinkForGuest = (token, room, mobileNumber, participantName) => {
    const participant = participantName ? '&participantName=' + participantName : '';
    const fullUrl = Tools.buildUrl(BASE_URL, `/api/v2/video/SmsVideoVisitLinkForGuest?room=${room}&mobileNumber=${mobileNumber}${participant}`);
    const params = {
        method: "POST",
        headers: {
            authorization: `bearer ${token}`,
            "Accept": "application/json",
            "Content-type": "application/json"
        }
    };

    const start = new Date();

    return fetch(fullUrl, params)
        .then(response => {
            if (response.status === 200) {
                logAPI("MBHWeb.Api.VideoVisit.SMSVisitLinkForGuest.Success", start, fullUrl, { room, mobileNumber, participantName }, room);
                return response.json();
            }
            else {
                logAPI("MBHWeb.Api.VideoVisit.SMSVisitLinkForGuest.Failure", start, fullUrl, { room, mobileNumber, participantName }, room);
                return Promise.reject(response);
            }
        })
        .catch(err => {
            logAPI("MBHWeb.Api.VideoVisit.SMSVisitLinkForGuest.Failure", start, fullUrl, { room, mobileNumber, participantName }, room);
            return Promise.reject(err);
        });
};

export const emailVideoVisitLinkForGuest = (token, room, email, participantName) => {
    const participant = participantName ? '&participantName=' + participantName : '';
    const fullUrl = Tools.buildUrl(BASE_URL, `/api/v2/video/EmailVideoVisitLinkForGuest?room=${room}&email=${email}${participant}`);
    const params = {
        method: "POST",
        headers: {
            authorization: `bearer ${token}`,
            "Accept": "application/json",
            "Content-type": "application/json"
        },
        body: JSON.stringify({ room, email })
    };

    const start = new Date();

    return fetch(fullUrl, params)
        .then(response => {
            if (response.status === 200) {
                logAPI("MBHWeb.Api.VideoVisit.EmailVisitLinkForGuest.Success", start, fullUrl, { room, email, participantName }, room);
                return response.json();
            }
            else {
                logAPI("MBHWeb.Api.VideoVisit.EmailVisitLinkForGuest.Failure", start, fullUrl, { room, email, participantName }, room);
                return Promise.reject(response);
            }
        })
        .catch(err => {
            logAPI("MBHWeb.Api.VideoVisit.EmailVisitLinkForGuest.Failure", start, fullUrl, { room, email, participantName }, room);
            return Promise.reject(err);
        });
};

export const cancelVideoVisitLink = (token, shareCode) => {
    const fullUrl = Tools.buildUrl(BASE_URL, `api/v1/video/CancelVideoVisitLink?shareCode=${shareCode}`);
    const params = {
        method: "POST",
        headers: {
            authorization: `bearer ${token}`,
            "Accept": "application/json",
            "Content-type": "application/json"
        },
    };

    const start = new Date();

    return fetch(fullUrl, params)
        .then(response => {
            if (response.status === 200) {
                logAPI("MBHWeb.Api.VideoVisit.CancelSharedLinkForGuest.Success", start, fullUrl, null, shareCode);
                return Promise.resolve(response.json());
            }
            else {
                logAPI("MBHWeb.Api.VideoVisit.CancelSharedLinkForGuest.Failure", start, fullUrl, null, shareCode);
                return Promise.reject(response);
            }
        })
        .catch(err => {
            logAPI("MBHWeb.Api.VideoVisit.CancelSharedLinkForGuest.Failure", start, fullUrl, null, shareCode);
            return Promise.reject(err);
        });
};

export const getShareLinkHistory = (token, room) => {
    const fullUrl = Tools.buildUrl(BASE_URL, `/api/v1/video/GetShareLinkHistory?room=${room}`);
    const params = {
        method: "GET",
        headers: {
            authorization: `bearer ${token}`,
            "Accept": "application/json",
            "Content-type": "application/json"
        },
    };

    const start = new Date();

    return fetch(fullUrl, params)
        .then(response => {
            if (response.status === 200) {
                logAPI("MBHWeb.Api.VideoVisit.ShareLinkHistory.Success", start, fullUrl, null, room);
                return Promise.resolve(response.json());
            }
            else {
                logAPI("MBHWeb.Api.VideoVisit.ShareLinkHistory.Failure", start, fullUrl, null, room);
                return Promise.reject(response);
            }
        })
        .catch(err => {
            logAPI("MBHWeb.Api.VideoVisit.ShareLinkHistory.Failure", start, fullUrl, null, room);
            return Promise.reject(err);
        });
};

export const getEmployeeTypes = () => {
    const fullUrl = Tools.buildUrl(BASE_URL, '/api/employee/GetEmployeeTypes');
    const start = new Date();
    return fetch(fullUrl).then(response => {
        logAPI("Api.SSO.getEmployeeTypes.Success", start, fullUrl);
        return response.json();
    }).catch(err => {
        // return from local json file (./employeeTypes.json)
        const { roles } = employeeTypes;
        if (roles && roles.providers && roles.staffs) {
            logAPI("Api.SSO.getEmployeeTypesLocal.Success", start);
            return employeeTypes;
        }
        else {
            logAPI("Api.SSO.getEmployeeTypesLocal.Failure", start);
            return Promise.reject("unable to read employeeTypes.json");
        }
    //    logAPI("Api.SSO.getEmployeeTypes.Failure", start, fullUrl);
    //    return Promise.reject(err);
    });
}

export const allowOrDenyGuest = (token, roomShareId, isAllowGuest) => {
    const url = Tools.buildUrl(BASE_URL, `/api/v2/video/${isAllowGuest ? "AllowGuestForVideoVisit" : "DenyGuestForVideoVisit"}?roomShareId=${roomShareId}`);
    const params = {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            authorization: `bearer ${token}`,
        }
    };
    const start = new Date();

    return fetch(url, params).then(response => {
        logAPI(`MBHWeb.Api.VideoVisit.${isAllowGuest ? "Allow" : "Deny"}.Post`, start, url, null, roomShareId);
        if (response && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI(`MBHWeb.Api.VideoVisit.${isAllowGuest ? "Allow" : "Deny"}.Post.Failure`, start, url, err, roomShareId);
        return Promise.reject(err);
    });

};

export const createVirtualRoom = (token, payload) => {
    const url = Tools.buildUrl(BASE_URL, `/api/v2/video/CreateVirtualRoom`);
    const params = {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            authorization: `bearer ${token}`,
        },
        body: JSON.stringify(payload)
    };
    const start = new Date();

    return fetch(url, params).then(response => {
        logAPI(`MBHWeb.Api.OnTheFlyVisitModal.Post`, start, url);
        if (response && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI(`MBHWeb.Api.OnTheFlyVisitModal.Post.Failure`, start, url, err);
        return Promise.reject(err);
    });

};